/**
 * Tính chất tài khoản
 */
export default {
  /**
   * Dư nợ
   */
  Debit: 0,
  /**
   * Dư có
   */
  Credit: 1,
  /**
   * Lưỡng tính
   */
  BothSide: 2,
};
